const config = {
  backend_url: "https://movies-ratings-dev.onrender.com",
//   backend_url_local: "${config.backend_url}",
};

export default config;